import React, {Fragment} from 'react';
import Box from '../../layout/Box';
import StoreOrderForm from './../forms/storeorderForm';
import StoreOrderList from './../lists/storeorderList';
import BoxEditor from "./../BoxEditor";
import Button from "../../form/Button";
import PrintButton from "../../form/PrintButton";
import {postData, sendRequest} from "../../../utils/request";
import connect from "react-redux/es/connect/connect";
import createEditor from "../../form/ComponentEditor";
import StoreOrderClaimEditor from "../StoreOrderClaimEditor";
import ModalEditor from "../ModalEditor";
import {CurrencyFormatter, ProductColumn, UnitFormatter} from "../../../utils/formatters";
import TextInput from "../../form/TextInput";
import {ifCompletedInput} from "../../../utils/other";
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import Modal from "../../layout/Modal";
import {showModal} from "../../../actions";

const orderTypes = {
    SALES_ORDER:  ordertype => ordertype + "" === "0",
    PURCHASE_ORDER: ordertype => ordertype + "" === "1",
};

const stateTypes = {
    RECEIVED_STATE: state => state + "" === "0",
    ACCEPTED_STATE: state => state + "" === "1",
    CONFIRMED_STATE: state => state + "" === "2",
    COMPLETED_STATE: state => state + "" === "3",
    CLAIM_STATE: state => state + "" === "4",
    WAITING_FOR_STOCK_STATE: state => state + "" === "5",
    CLAIM_CHECK_STATE: state => state + "" === "6"
};

const sortable = true;
const filterable = true;

class ClaimDiff extends React.Component {

    state = {
        fullcount: 0,
        items: {}
    };

    render() {
        return (
            <Modal
                state="on"
                size="large"
                header="Eltérés módosítása"
                buttons={[
                    {
                        text: "Mégse",
                        props: {color: "default", disabled: this.props.isLoading},
                        onClose: true,
                        onClick: async () => {
                            this.props.cancel();
                        }
                    },
                    {
                        text: "Mehet",
                        props: {color: "primary", disabled: !Object.keys(this.state.items).length || this.props.isLoading},
                        onClick: async () => {
                            this.props.acceptCorrection({items: Object.keys(this.state.items).map((id) => ({id, qty: this.state.items[id]}))});
                        }
                    }
                ]}
            >
                <SelectorGrid
                    {...this.props.getFieldProps("items")}
                    ref={(e) => this.items = e}
                    className={"p-small-table"}
                    exports={[{as: "excel", label: "Excel", icon: "far fa-file-excel"}]}
                    view={["id", "name", "qty", "product_id"]}
                    filter={[{field: "diffqty", value: 0, operator: "!="}]}
                    onItemUpdate={async (item, oldItem, field, rowIndex, {listfieldComponentConfig}) => {
                        const items = {...this.state.items};
                        items[item.id] = parseInt(item.diffqty);
                        this.setState({items});
                        return false;
                    }}
                    columns={{
                        "displayname": {
                            ...ProductColumn("product_id"),
                            width: 2,
                        },
                        "barcode": {
                            header: 'Vonalkód',
                            width: 1,
                            sortable,
                            filterable
                        },
                        "listprice": {
                            header: 'Ár',
                            width: 2,
                            sortable,
                            filterable,
                            renderer: CurrencyFormatter,
                            className: "currency"
                        },
                        "qty": {
                            header: 'Darabszám',
                            width: 2,
                            sortable,
                            filterable,
                            renderer: (value, row) => UnitFormatter(value || 0, row.unit),
                            className: "unit"
                        },
                        "pickedqty": {
                            header: orderTypes.SALES_ORDER(this.props.values.ordertype) ? "Kiszedve" : "Bevételezve",
                            width: 2,
                            sortable,
                            filterable,
                            renderer: (value, row) => UnitFormatter(value || 0, row.unit),
                            className: "unit"
                        },
                        "diffqty": {
                            header: "Tényleges db",
                            width: 2,
                            sortable,
                            aggregation: (value, row) => UnitFormatter(Object.values(this.state.items).reduce((a, b) => Math.abs(a) + Math.abs(b), 0) || 0, row.unit),
                            renderer: (value, row) => UnitFormatter(Math.abs(this.state.items[row.id] || 0), row.unit),
                            className: "unit",
                            editor:
                                (parent) =>
                                    (props, value) =>
                                        <TextInput type="number" name="diffqty" label={false} focus
                                                   value={Math.abs(this.state.items[props.rowData.id] || 0)}
                                                   onKeyDown={(e, field, value) => {
                                                       ifCompletedInput(e) && parent.onEditorValueChange(props, value, {ignoreEqual: true});
                                                   }}
                                                   onBlur={(e, field, value) => parent.onEditorValueChange(props, value, {ignoreEqual: true})}/>
                        }
                    }}
                    aggregations={{
                        fields: {
                            "qty": {
                                field: "qty", type: "SUM"
                            }
                        }
                    }}
                    onLoadCompleted={(response) => {
                        this.setState({fullcount: parseInt(response.fullcount)});
                    }}
                    onSort={(field, direction) => {
                        if (field === "diffqty" && !!Object.keys(this.state.items).length) {
                            return {
                                expression: "FIELD({{id}}, " + Object.keys(this.state.items).sort((a, b) => this.state.items[a] - this.state.items[b]).join(", ") + ")",
                                direction
                            };
                        }
                    }}
                    listfield="items"
                    data={this.props.values}
                    orderBy={{field: "displayname", direction: "ASC"}}
                    componentConfig={this.props.componentConfig}
                />
            </Modal>
        );
    }
}

class AcceptButton extends React.Component {

    state = {
        disabled: true
    }

    componentDidMount() {
        this.check();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.values[this.props.componentConfig.idfield] !== prevProps.values[prevProps.componentConfig.idfield] || this.props.values.state !== prevProps.values.state) {
            this.check();
        }
    }

    check = () => {
        this.setState({disabled: true}, () => {
            this.orders && this.orders.abort();
            this.orders = sendRequest({
                option: "componentlist",
                component: this.props.componentConfig.componentname,
                filter: [
                    {field: "client_component", value: this.props.componentConfig.componentname},
                    {field: "client_component_id", value: this.props.values[this.props.componentConfig.idfield]},
                    {field: "state", value: "3", operator: "!="},
                ]
            });
            this.orders.then((data) => {
                this.setState({disabled: !!data.items.length});
            });
        });
    }

    render() {
        return (
            <Button
                type="button"
                disabled={this.props.isLoading || this.state.disabled}
                color="primary"
                className={"pull-right"}
                onClick={this.props.storeorderActions}
            >
                {stateTypes.CLAIM_STATE(this.props.values.state) ? "Elfogadom" : "Mehet"}
            </Button>
        );
    }
}

export class StoreOrderEditor extends React.Component {

    state = {
        diff: null,
        closeOrder: false,
        claimDiff: false
    }

    componentDidUpdate(prevProps, prevState, prevContext) {
        if (prevProps.values[this.props.componentConfig.idfield] !== this.props.values[this.props.componentConfig.idfield]) {
            this.setState({diff: null, closeOrder: false, claimDiff: false});
        }
    }

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.editor && this.editor.focus();
    }

    internalstoreActions = async (action) => {
        const values = this.props.values;
        await this.props.processAction(async () => {
            const response = await postData({
                action: 'internal_store.' + action,
                id: values[this.props.componentConfig.idfield]
            });
            if (response.success) {
                this.list && this.list.refreshBackground();
                this.form && this.form.refreshBackground();
            }
            return response;
        });
    }

    booklogstoreActions = async (action) => {
        const values = this.props.values;
        let res = null;
        await this.props.processAction(async () => {
            res = await postData({
                action: 'booklog_store.' + action,
                orderid: values[this.props.componentConfig.idfield]
            });
            return res;
        });
        return res;
    }

    storeorderActions = async (action, params = {}) => {
        const values = this.props.values;
        await this.props.processAction(async () => {
            const response = await postData({
                action: 'storeorder.' + action,
                [this.props.componentConfig.idfield]: values[this.props.componentConfig.idfield],
                ...params
            });
            if (response.success) {
                this.list && this.list.refreshBackground();
                this.form && this.form.refreshBackground();
            }
            return response;
        });
    }

    printDocuments = async () => {
        const values = this.props.values;
        await this.props.processAction(async () => {
            const response = await postData({
                action: 'storeorder.printDocuments',
                [this.props.componentConfig.idfield]: values[this.props.componentConfig.idfield]
            });
            if (response.success) {
                this.list && this.list.refreshBackground();
                this.form && this.form.refreshBackground();
            }
            return response;
        });
    }

    getFieldProps = (name) => {
        let props = {...this.props.getFieldProps(name)};
        props = {...props, ...this.props[name]};
        props.disabled = props.disabled || stateTypes.COMPLETED_STATE(this.props.values.state) || stateTypes.CLAIM_STATE(this.props.values.state);
        if (name === "pickedqty") {
            props.disabled = props.disabled || (this.props.values.ordertype !== undefined
                &&
                this.props.values.serviceprovider_type !== "internal_store");
        }
        return props;
    }

    closeOrderAction = async () => {
        if (this.state.diff !== null) {
            if (this.state.diff) {
                if (this.state.closeOrder) {
                    try {
                        await this.storeorderActions('closeOrder');
                        this.setState({closeOrder: false});
                    } catch (e) {
                        this.setState({closeOrder: false});
                        throw e;
                    }
                } else {
                    this.setState({closeOrder: true});
                }
            } else {
                await this.storeorderActions('closeOrder');
            }
        }
    }

    render() {
        const clientFields = this.props.in === undefined && this.props.out === undefined && this.props.values.client_component && (!this.props.client || !(this.props.client && this.props.client.values[this.props.client.componentConfig.idfield] + "" === "" + this.props.values.client_component_id));
        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;
        const Other = this.props.other || Fragment;
        const props = {...this.props};
        if (props.filter !== undefined && !Array.isArray(props.filter)) {
            props.filter = [props.filter];
        } else if (Array.isArray(props.filter)) {
            props.filter = [...props.filter];
            if (props.in) {
                props.filter.push({
                    field: "ordertype",
                    value: 1
                });
            } else if (props.out) {
                props.filter.push({
                    field: "ordertype",
                    value: 0
                });
            }
        }
        const actionButtons = [];
        if (stateTypes.COMPLETED_STATE(props.values.state)) {
            actionButtons.push(
                <PrintButton
                    {...props}
                    className="pull-right"
                />
            );
        }
        if (this.props.client && this.props.client.componentConfig.componentname === this.props.componentConfig.componentname && (stateTypes.ACCEPTED_STATE(props.values.state) || stateTypes.CONFIRMED_STATE(props.values.state))) {
            actionButtons.push(
                <Button
                    key="1"
                    disabled={!this.props.values[this.props.componentConfig.idfield] || this.props.isLoading}
                    color="danger"
                    className="pull-left"
                    onClick={this.props.deleteForm}
                >
                    Törlés
                </Button>
            );
        }
        if (
            props.values.ordertype !== undefined
            &&
            props.values.serviceprovider_type === "internal_store"
        ) {
            if (stateTypes.CONFIRMED_STATE(props.values.state)) {
                actionButtons.push(
                    <Button
                        type="button"
                        disabled={props.isLoading || this.state.diff === null}
                        color="primary"
                        className={"pull-right"}
                        onClick={this.closeOrderAction}
                    >
                        {orderTypes.SALES_ORDER(props.values.ordertype) ? "Kiszedve" : "Bevételezve"}
                    </Button>
                );
                actionButtons.push(
                    <Button
                        privileges={["storeorder_bulkaccept"]}
                        type="button"
                        disabled={props.isLoading}
                        color="default"
                        className={"pull-right"}
                        onClick={() => this.internalstoreActions('bulkAccept')}
                    >
                        {orderTypes.SALES_ORDER(props.values.ordertype) ? "Összes kiszedve" : "Összes bevételezve"}
                    </Button>
                );
            }
        }
        if (
            stateTypes.CLAIM_STATE(props.values.state)
        ) {
            if (this.props.values.serviceprovider_type === "booklog_store") {
                actionButtons.push(
                    <Button
                        tooltip={this.props.client && this.props.client.componentConfig.componentname === this.props.componentConfig.componentname ? "Ugye csak viccelsz?" : null}
                        type="button"
                        disabled={props.isLoading}
                        color="warning"
                        className={"pull-right"}
                        onClick={() => {
                            //this.setState({claimDiff: true});
                            if (this.props.values.serviceprovider_type !== "internal_store") {
                                this.setState({claimDiff: true});
                            } else {
                                this.storeorderActions('claimCorrection');
                            }
                        }}
                    >
                        Módosítás
                    </Button>
                );
            }
        }
        if (this.props.values.serviceprovider_type === "booklog_store" && orderTypes.SALES_ORDER(this.props.values.ordertype)) {
            actionButtons.push(
                <Button
                    type="button"
                    disabled={props.isLoading}
                    color="default"
                    className={"pull-right"}
                    onClick={async () => {
                        const res = await this.booklogstoreActions('getOrderStatus');
                        this.props.showModal({
                            size: "small",
                            theme: "default",
                            header: "Státusz",
                            text: res.status
                        });
                    }}
                >
                    Állapot lekérdezés
                </Button>
            );
        }
        if (this.props.values.serviceprovider_type === "external_store") {
            actionButtons.push(
                <Button
                    type="button"
                    disabled={props.isLoading}
                    color="primary"
                    className={"pull-right"}
                    onClick={this.props.saveForm}
                >
                    Mentés
                </Button>
            );
        }
        if (
            stateTypes.CLAIM_STATE(props.values.state)
            ||
            stateTypes.CLAIM_CHECK_STATE(props.values.state)
        ) {
            actionButtons.push(
                <AcceptButton
                    {...props}
                    storeorderActions={() => this.storeorderActions('acceptMismatch')}
                />
            );
            /*if (orderTypes.PURCHASE_ORDER(props.values.ordertype)) {
                actionButtons.push(
                    <Button
                        type="button"
                        disabled={props.isLoading}
                        color="danger"
                        className={"pull-right"}
                        onClick={() => this.storeorderActions('declineMismatch')}
                    >
                        {stateTypes.CLAIM_STATE(props.values.state) ? "Nem fogadom el" : "Hibás eltérés"}
                    </Button>
                );
            }*/
        }
        return (
            <Fragment>
                <List
                    {...props}
                    theme="default"
                    header={props.componentEditor === "storeorderIn" || props.in ? "Bevételezés rendelések" : (props.componentEditor === "storeorderOut" || props.out ? "Kiszedés rendelések" : "Raktári rendelések")}
                >
                    <StoreOrderList
                        ref={(el) => this.list = el}
                        {...props}
                        clientFields={clientFields}
                        loadForm={this.loadForm}
                    />
                </List>
                <Editor
                    {...props}
                    ref={(editor) => this.editor = editor}
                    theme="default"
                    header={"Raktári rendelés adatai"}
                    footer={actionButtons}
                >
                    <StoreOrderForm
                        ref={(form) => this.form = form}
                        {...props}
                        clientFields={clientFields}
                        orderTypes={orderTypes}
                        stateTypes={stateTypes}
                        closeOrderAction={this.closeOrderAction}
                        cancelCloseOrderAction={() => this.setState({closeOrder: false})}
                        closeOrder={this.state.closeOrder}
                        diff={this.state.diff}
                        setDiff={(diff) => this.setState({diff})}
                        getFieldProps={this.getFieldProps}
                        diffModal={
                            this.state.claimDiff
                            &&
                            <ClaimDiff
                                {...props}
                                orderTypes={orderTypes}
                                stateTypes={stateTypes}
                                cancel={() => {
                                    this.setState({claimDiff: false});
                                }}
                                acceptCorrection={async (params) => {
                                    await this.storeorderActions('claimCorrection', params);
                                    this.setState({claimDiff: false});
                                }}
                            />
                        }
                    />
                </Editor>
                <Other>
                    {
                        props.values[props.componentConfig.idfield] && props.in === undefined && props.out === undefined &&
                        <StoreOrderClaimEditor
                            listFilter={[
                                {
                                    field: "storeorder",
                                    value: props.values[props.componentConfig.idfield]
                                }
                            ]}
                            editor={ModalEditor}
                            selection={null}
                        />
                    }
                </Other>
            </Fragment>
        );
    }
}

export default connect((state) => {
    return {
        till: state.app.till
    }
},{showModal})(createEditor({
    componentName: "storeorder",
    WrappedComponent: StoreOrderEditor,
    props: {
        view: "admin",
        componentActions: (action, data, params) => {
            data = {...data};
            delete data.client;
            return {action,data,params};
        }
    }
}));
